import React, {useState} from "react";
import {AppBar, IconButton, Toolbar, withStyles, withTheme} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {loginApp, logoutApp} from "../contexts/GlobalProviders";
import {withNotification} from "../contexts/NotificationContext";
import {Menu} from "@material-ui/icons"
import {getTheme, setTheme} from "../utils/storage";
import RightTopMenu from "./RightMenuTopBar";
import * as classnames from "classnames";
import {ReactSVG as Svg} from 'react-svg';
import {useAuth} from 'reactfire';

const styles = theme => ({
    grow: {
        flexGrow: 1,
        textAlign: 'center',
    },
    menuButtons: {
        display: 'flex',
        flexDirection: 'row'
    },
    calendarButton: {
        color: 'white',
    },
    appBar: {
        backgroundColor: theme.palette.type === 'light' && '#440099',
        color: 'white'
    },
    logo: {
        marginTop: '-15px',
        '& svg': {
            fill: '#ffffff',
            height: 50,
            [theme.breakpoints.down('sm')]: {
                height: 40,
            }
        }
    },
    logoClock: {
        marginTop: '5px',
        '& svg': {
            fill: '#ffffff',
            height: 40,
            [theme.breakpoints.down('sm')]: {
                height: 20,
            }
        }
    }
});

const TopAppBar = React.forwardRef((props, ref) => {
    const [menu, setMenu] = props.menu;
    const [darkTheme, setDarkTheme] = useState(!!getTheme());
    const auth = useAuth()

    const login = loginApp;

    const logout = logoutApp;

    const toggleTheme = () => {
        setTheme(!darkTheme);
        // props.notification.notify({message: 'Atualize a pagina para alterar o tema', color: 'success'});
        setDarkTheme(!darkTheme);
        props.theme.setCustomTheme(getTheme() ? 'dark' : 'light')
    };

    const {classes} = props;

    return <AppBar position="relative" className={classnames('draggable', classes.appBar)} color="default" ref={ref}>
        <Toolbar>
            <Grid container alignItems={"center"}>
                <Grid item xs={4} className={classes.menuButtons}>
                    {
                        auth.currentUser && <IconButton className={classes.calendarButton} onClick={() => setMenu(!menu)}><Menu/></IconButton>
                    }
                </Grid>
                <Grid item xs={4}>
                    <Grid container alignItems={"center"} direction={'column'}>
                        <Svg src={`${process.env.PUBLIC_URL}/images/logoClock.svg`} className={classes.logoClock}/>
                    </Grid>
                </Grid>
                {
                    auth.currentUser &&
                        <RightTopMenu
                            toggleTheme={toggleTheme}
                            login={login}
                            logout={logout}/>

                }
            </Grid>
        </Toolbar>
    </AppBar>;
});

TopAppBar.propTypes = {};

export default withNotification(withTheme(withStyles(styles)(TopAppBar)));
